// imagePreview.js — helpers of the large-image preview component
// (components/ImagePreview/ImagePreviewLightbox.vue, owner 2026-10-15).
// Pure (no vue import): tests/unit/imagePreviewLightbox.spec.js drives them.

import { isEscapeKey } from './sellerProductRow';

// isEscapeKey is the /seller/products lightbox's own helper (one definition).
export { isEscapeKey };

/** isTabKey(event) — Tab / Shift+Tab. */
export function isTabKey(e) {
  return !!e && (e.key === 'Tab' || e.keyCode === 9);
}

/**
 * previewOf(src, caption, trigger) → the lightbox `preview` prop
 * ({ src, caption, trigger? }), or null when there is no picture to enlarge
 * (a blank src: the no-image placeholder is not clickable). `src` is kept byte
 * for byte apart from surrounding whitespace — signed CDN URLs must not be
 * rewritten (see ./cdnImage).
 */
export function previewOf(src, caption, trigger) {
  const s = src === null || src === undefined ? '' : String(src).trim();
  if (!s) return null;
  const out = { src: s, caption: caption === null || caption === undefined ? '' : String(caption).trim() };
  if (trigger) out.trigger = trigger;
  return out;
}

export default { isEscapeKey, isTabKey, previewOf };
